export default __webpack_public_path__ + "static/media/ico-rds-score-elevated.75524f8b.svg";